import { Component, forwardRef, Inject, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from '../../../service/app.service';
import { FieldService } from '../../../service/field.service';
import { PartnerAdvancedSearchAddPropertiesDialog } from '../../advanced-search/partner-advanced-search/partner-advanced-search-add-properties-dialog.component';
import { PartnerAdvancedSearchComponent } from '../../advanced-search/partner-advanced-search/partner-advanced-search.component';
import { LocalizationPipe } from '../../pipe';
import { AbstractSearchFieldComponent } from '../abstract-search-field.component';
import { SearchTargetType } from '../search-field.component';
import { SearchFieldService } from '../search-field.service';
import { PartnersPropertySearchInputComponent } from './partners-property-search-input.component';

@Component({
    selector: 'partners-search-field',
    template: require('./partners-search-field.component.html'),
    styles: [require('../search-field.component.css')],
})
export class PartnersSearchFieldComponent extends AbstractSearchFieldComponent {

    @ViewChild(PartnerAdvancedSearchComponent) partnerAdvancedSearch: PartnerAdvancedSearchComponent;

    @ViewChild(PartnerAdvancedSearchAddPropertiesDialog) addPropertiesDialog: PartnerAdvancedSearchAddPropertiesDialog;

    @ViewChildren(PartnersPropertySearchInputComponent) private partnersPropertySearchInputs: QueryList<PartnersPropertySearchInputComponent>;

    constructor(
        @Inject(forwardRef(() => FieldService)) fieldService: FieldService,
        @Inject(forwardRef(() => SearchFieldService)) searchFieldService: SearchFieldService,
        @Inject(forwardRef(() => MatDialog)) matDialog: MatDialog,
        @Inject(forwardRef(() => ViewContainerRef)) vcRef: ViewContainerRef,
        @Inject(forwardRef(() => AppService)) appService: AppService,
        @Inject(forwardRef(() => LocalizationPipe)) localizationPipe: LocalizationPipe
    ) {
        super(fieldService, searchFieldService, matDialog, vcRef, appService, localizationPipe);
        this.searchTarget = SearchTargetType.PARTNERS;
    }

    openAddPropertiesDialog(advancedSearchProperties: { name: string, label: string }[]): void {
        this.close();
        this.advancedSearchProperties = advancedSearchProperties;
        setTimeout(() => this.addPropertiesDialog.open(), 400);
    }

    closeAddPropertiesDialog(updatedSearchFields: string[]): void {
        if (updatedSearchFields) {
            this.partnerAdvancedSearch.updateSearchFields(updatedSearchFields);
        }
        setTimeout(() => this.open(), 400);
    }

    performClear(): void {
        this.partnerAdvancedSearch?.clearAll();
        this.clearInputs();
    }

    protected updateAdvancedSearch(fieldsToSaveBody: any): void {
        this.partnerAdvancedSearch?.updateLocalStorage(fieldsToSaveBody);
        this.partnerAdvancedSearch?.initAllConfigurations();
    }

    protected getEncodedRawValues(): void {
        let body: any = {};
        this.partnersPropertySearchInputs?.forEach(property => Object.assign(body, property.getFormValue(true)));
        return body;
    }

    protected getRawValues() {
        let body: any = {};
        this.partnersPropertySearchInputs?.forEach(property => Object.assign(body, property.getFormValue(false)));
        return body;
    }

    protected refreshInputConfigurations(): void {
        this.partnersPropertySearchInputs.forEach(input => {
            input.refreshConfiguration();
        });
    }

}